module.exports = __webpack_public_path__ + "img/gratitude-static.a692697d.png";